import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	missingResponder: {
		id: 'eoc.escalation-policies.ui.actions.missing-responder.no-translate',
		defaultMessage: 'Missing Responder',
		description: 'Label of lozenge when there is missing responder',
	},
	collapse: {
		id: 'eoc.escalation-policies.ui.actions.collapse.no-translate',
		defaultMessage: 'Collapse',
		description: 'Label of collapse button',
	},
	expand: {
		id: 'eoc.escalation-policies.ui.actions.expand.no-translate',
		defaultMessage: 'Expand',
		description: 'Label of expand button',
	},
});

export default messages;
